import { takeLatest, takeEvery, all } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../_config";

import {
  forgotPassword,
  getUserProfile,
  loginUser,
  loginUserWithOtp,
  logoutUser,
  updateUserProfile,
  // deleteUser,
  //AutoLogin,
  loginWithEmail,
  resetPassword,
  registration,
  updateDisplayName,
  checkValidToken,
  getRegistrationFieldsData,
  saveNotification,
  updateDob,
  updateEmail,
  saveUserPicks,
} from "./userSaga";

import { getCities, getCountries, getStates, newsletterSignup, getGameStatusText } from "./commonSaga";

import {
  applyLeagueCode,
  getEvents,
  getGameDetails,
  getGroupLeaderboard,
  getGroups,
  getLeaderboard,
  getLeagueLeaderboard,
  getMostPopularPicks,
  getMyTeam,
  getPastRodeoEvents,
  getPerformances,
  getRodeoEvents,
  getShareImageLink,
  getUpcomingEvents,
  getVsLeagueLeaderboard,
  getYourPicks,
  pickRider,
  tvImage,
  winningTicketResults,
  getActivePerformances,
  getCategorizedPerformances,
  getCategorizedRodeoEvents,
  getCategorizedEventGroups,
  getEventGroupsLeaderboard,
  getRodeoLeaderboard,
  getPerformanceLeaderboard,
  getSidebarPerformanceLeaderboard,
  getSidebarRodeoLeaderboard,
  getSidebarEventGroupsLeaderboard,
  getRodeoEventEvents,
  postRodeoEventUserPick,
  getRodeoEventYourPicks,
  getMyPickList,
  saveCoupon,
  groupTvImageDetails,
  getWinningTicketResults,
} from "./eventSaga";

import { getCmsContent, getBlocks, getLivePerformance } from "./cmsSaga";

export function* sagas() {
  yield all([
    // user saga
    takeLatest(SAGA_ACTIONS.AUTH.DETAILS, getUserProfile),
    takeLatest(SAGA_ACTIONS.AUTH.LOGIN, loginUser),
    // takeLatest(SAGA_ACTIONS.AUTH.AUTOLOGIN, AutoLogin),
    takeLatest(SAGA_ACTIONS.AUTH.LOGIN_WITH_OTP, loginUserWithOtp),
    takeLatest(SAGA_ACTIONS.AUTH.LOGIN_WITH_EMAIL, loginWithEmail),
    takeLatest(SAGA_ACTIONS.AUTH.FORGOT_PASSWORD, forgotPassword),
    takeLatest(SAGA_ACTIONS.AUTH.RESET_PASSWORD, resetPassword),
    takeLatest(SAGA_ACTIONS.AUTH.REGISTRATION, registration),
    takeLatest(SAGA_ACTIONS.AUTH.UPDATE_PROFILE, updateUserProfile),
    takeLatest(SAGA_ACTIONS.AUTH.LOGOUT, logoutUser),
    // takeLatest(SAGA_ACTIONS.AUTH.DELETE_USER, deleteUser),
    takeLatest(SAGA_ACTIONS.AUTH.UPDATE_DISPLAY_NAME, updateDisplayName),
    takeLatest(SAGA_ACTIONS.AUTH.UPDATE_DOB, updateDob),
    takeLatest(SAGA_ACTIONS.AUTH.UPDATE_EMAIL, updateEmail),
    takeLatest(SAGA_ACTIONS.AUTH.CHECK_VALID_TOKEN, checkValidToken),
    takeLatest(SAGA_ACTIONS.AUTH.REGISTRATION_FIELDS, getRegistrationFieldsData),
    takeLatest(SAGA_ACTIONS.AUTH.SAVE_NOTIFICATION, saveNotification),
    takeLatest(SAGA_ACTIONS.AUTH.SAVE_USER_PICKS, saveUserPicks),

    //COMMON Saga
    // takeLatest(SAGA_ACTIONS.COMMON.GET_SETTINGS, getSettings),
    takeLatest(SAGA_ACTIONS.COMMON.COUNTRIES, getCountries),
    takeLatest(SAGA_ACTIONS.COMMON.STATES, getStates),
    takeLatest(SAGA_ACTIONS.COMMON.CITIES, getCities),
    // takeLatest(SAGA_ACTIONS.COMMON.CONTACTUS, contactUs),
    // takeLatest(SAGA_ACTIONS.COMMON.SEO_LIST, getSEOList),
    takeLatest(SAGA_ACTIONS.COMMON.NEWSLETTER_SIGNUP, newsletterSignup),
    takeLatest(SAGA_ACTIONS.COMMON.GET_GAME_STATUS_TEXT, getGameStatusText),

    //Event Saga
    takeLatest(SAGA_ACTIONS.EVENT.RODEO_EVENT_EVENTS, getRodeoEventEvents),
    takeLatest(SAGA_ACTIONS.EVENT.RODEO_EVENT_USER_PICK, postRodeoEventUserPick),
    takeLatest(SAGA_ACTIONS.EVENT.RODEO_EVENT_YOUR_PICKS, getRodeoEventYourPicks),
    takeLatest(SAGA_ACTIONS.EVENT.GROUPS, getGroups),
    takeLatest(SAGA_ACTIONS.EVENT.RODEO_EVENTS, getRodeoEvents),
    takeLatest(SAGA_ACTIONS.EVENT.PAST_RODEO_EVENTS, getPastRodeoEvents),
    takeLatest(SAGA_ACTIONS.EVENT.UPCOMING_EVENTS, getUpcomingEvents),
    takeLatest(SAGA_ACTIONS.EVENT.PERFORMANCES, getPerformances),
    takeLatest(SAGA_ACTIONS.EVENT.EVENTS, getEvents),
    takeLatest(SAGA_ACTIONS.EVENT.PICK_RIDER, pickRider),
    takeLatest(SAGA_ACTIONS.GAME_DETAILS, getGameDetails),
    takeLatest(SAGA_ACTIONS.EVENT.YOUR_PICKS, getYourPicks),
    takeLatest(SAGA_ACTIONS.EVENT.MY_TEAM, getMyTeam),
    takeLatest(SAGA_ACTIONS.EVENT.MY_CORRECT_PICKS, winningTicketResults),
    takeLatest(SAGA_ACTIONS.EVENT.APPLY_LEAGUE_CODE, applyLeagueCode),
    takeLatest(SAGA_ACTIONS.EVENT.GET_SHARE_IMAGE_LINK, getShareImageLink),
    takeLatest(SAGA_ACTIONS.EVENT.MOST_POPULAR_PICKS, getMostPopularPicks),
    takeLatest(SAGA_ACTIONS.EVENT.GROUP_LEADER_BOARD, getGroupLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.LEADERBOARD, getLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.LEAGUE_LEADERBOARD, getLeagueLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.VS_LEAGUE_LEADERBOARD, getVsLeagueLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.TV_IMAGE, tvImage),
    takeLatest(SAGA_ACTIONS.EVENT.GROUP_TV_DETAILS, groupTvImageDetails),
    takeLatest(SAGA_ACTIONS.EVENT.ACTIVE_PERFORMANCES, getActivePerformances),
    takeLatest(SAGA_ACTIONS.EVENT.CATEGORIZED_PERFORMANCES, getCategorizedPerformances),
    takeLatest(SAGA_ACTIONS.EVENT.CATEGORIZED_RODEO_EVENTS, getCategorizedRodeoEvents),
    takeLatest(SAGA_ACTIONS.EVENT.CATEGORIZED_EVENT_GROUPS, getCategorizedEventGroups),
    takeLatest(SAGA_ACTIONS.EVENT.EVENT_GROUPS_LEADERBOARD, getEventGroupsLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.RODEO_LEADERBOARD, getRodeoLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.PERFORMANCE_LEADERBOARD, getPerformanceLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.SIDEBAR_PERFORMANCE_LEADERBOARD, getSidebarPerformanceLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.SIDEBAR_RODEO_LEADERBOARD, getSidebarRodeoLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.SIDEBAR_EVENT_GROUPS_LEADERBOARD, getSidebarEventGroupsLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.MY_PICK_LIST, getMyPickList),
    takeLatest(SAGA_ACTIONS.EVENT.SAVE_COUPON, saveCoupon),
    takeLatest(SAGA_ACTIONS.EVENT.WINNING_TICKET_RESULTS, getWinningTicketResults),

    //CMS Saga
    takeLatest(SAGA_ACTIONS.CMS.GET_CMS, getCmsContent),
    takeEvery(SAGA_ACTIONS.CMS.GET_BLOCKS, getBlocks),
    takeLatest(SAGA_ACTIONS.CMS.GET_LIVE_PERFORMANCE, getLivePerformance),
    // takeLatest(SAGA_ACTIONS.CMS.GET_GAME_CMS, getGameCmsContent),
  ]);
}
